(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const donationModules = document.querySelectorAll(".donation-block");

        Array.prototype.forEach.call(donationModules, (el, i) => {
            const currentModule = el;
            const donationAmountMenuRadios = currentModule.querySelectorAll(".donation-amount-menu input[type='radio']");
            const selectedDonationType = currentModule.querySelector(".donation--campaign");

            Array.prototype.forEach.call(donationAmountMenuRadios, (el, i) => {
                const donationAmountMenuRadio = el;

                donationAmountMenuRadio.addEventListener("change", () => {
                    donation.changeDonationValue(currentModule, donationAmountMenuRadio);
                });
            });

            if (selectedDonationType) {
                selectedDonationType.addEventListener("change", () => {
                    const activeSelectedDonationType = selectedDonationType.querySelector('option:checked');
                    const symbolAttribute = activeSelectedDonationType.getAttribute('data-symbol');
                    const symbol = symbolAttribute !== undefined && symbolAttribute !== null ? symbolAttribute : "?";
                    donation.changeDonationType(currentModule, selectedDonationType, symbol);
                });
            }
        });
    });

    const donation = {
        data: {
            urlDonationSingle: "https://my.rethink.org/donorhub/No_Fuss_donation.aspx",
            maxDonationAmount: 9999
        },
        changeDonationValue: function (donationModule, radio) {
            const isOtherAmountDonation = radio.classList.contains("other-radio");
            const donationImgEl = donationModule.querySelector(".donation--img");
            const donationCopyEl = donationModule.querySelector(".donation--copy");
            const donationButtonEl = donationModule.querySelector(".donate-btn-wrapper a");
            const donationValueEls = donationModule.querySelectorAll(".donation--value");
            let donationRadioValue = radio.value;
            const donationRadioCopy = radio.getAttribute("data-text");
            const donationRadioImg = radio.getAttribute("data-img");
            const donationCampaign = document.querySelector('.donation--campaign option:checked');
            const symbolAttribute = donationCampaign.getAttribute('data-symbol');
            const symbol = symbolAttribute !== undefined && symbolAttribute !== null ? symbolAttribute : "?";

            this.updateValue(donationModule, donationButtonEl, donationValueEls, donationRadioValue, symbol);

            //is-single (not multi)
            if (!donationModule.classList.contains("is-multi")) {
                donationCopyEl.innerHTML = donationRadioCopy;
            }

            //is-multi
            if (donationModule.classList.contains("is-multi")) {
                donationImgEl.src = donationRadioImg;
                donationCopyEl.innerHTML = donationRadioCopy;
            }

            if (isOtherAmountDonation) {
                const input = donationModule.querySelector(".other-input");
                input.classList.remove("is-d-none");
                input.focus();

                input.addEventListener("keyup", (event) => {
                    if (input.value > this.data.maxDonationAmount) {
                        donationRadioValue = this.data.maxDonationAmount;
                        input.value = donationRadioValue;
                    } else {
                        if (!input.validity.valid) {
                            input.value = donationRadioValue;
                        } else {
                            donationRadioValue = Math.floor(input.value);
                            this.updateValue(donationModule, donationButtonEl, donationValueEls, donationRadioValue, symbol);
                        }
                    }
                });

            } else {
                const input = donationModule.querySelector(".other-input");
                input.classList.add("is-d-none");
                input.blur();
            }
        },
        changeDonationType: function (donationModule, select, symbol) {
            const donationButtonEl = donationModule.querySelector(".donate-btn-wrapper a");
            const selectedAmount = donationModule.querySelector(".donation-amount-menu input[type='radio']:checked");
            donationButtonEl.setAttribute("href", `${select.value}${symbol}amount=${selectedAmount.value}`);
        },
        updateValue: function (donationModule, donationButtonEl, donationValueEls, donationRadioValue, donationQuerySymbol) {
            if (!donationModule.classList.contains("is-multi")) {
                donationButtonEl.setAttribute("href", `${this.data.urlDonationSingle}${donationQuerySymbol}amount=${donationRadioValue}`);
            } else {
                const donationUrl = donationModule.querySelector(".donation--campaign");
                donationButtonEl.setAttribute("href", `${donationUrl.value}${donationQuerySymbol}amount=${donationRadioValue}`);
            }

            Array.prototype.forEach.call(donationValueEls, (el, i) => {
                el.innerHTML = donationRadioValue;
            });
        }
    };
})();